export default __webpack_public_path__ + "static/1-ab900a1e4a63ca32f1d7a9615c4a1f45.png";